import React, { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { LinkButton } from '../../App/Components/ButtonWithText/style'
import { useHistory, useParams } from '../../Router'

import {
  CardData,
  InnerCardContainer,
  OuterCardContainer,
  StyledText,
  StyledTitle,
} from './style'
import { LastMinutePrice } from '../LastMinutePrice/LastMinutePrice'
import { ISettingValues } from '../../Settings/ISettings'
import { ILastMinute } from '../store/ILastMinute'

type Props = {
  lastMinute: ILastMinute
  settings: ISettingValues
}

export const LastMinuteCard = ({ settings, lastMinute }: Props) => {
  const { t } = useTranslation()
  const history = useHistory()
  const { establishmentId } = useParams<{ [key: string]: string }>()
  const { fontColor, showPrice, highlightColor, backgroundColor } = settings
  const { activities, description, lastMinutePrice, id } = lastMinute

  const startDate = activities[0].startsAt
  const hour = startDate.format('LT')
  const dateFull = startDate.format('dddd, D MMM YYYY')
  const isShowActivitiesWithNoDuration =
    settings.onlineAppointmentsShowActivitiesWithNoDuration

  const regularTotal = activities.reduce(
    (total, activity) => total + activity.price,
    0
  )

  /*
   * OB-506: absolute path so the URL is portable when copied via
   * right-click "Copy Link Address" / long-press "Copy link".
   */
  const bookUrl = `/${establishmentId}/last-minutes/${id}/book`

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (
      e.defaultPrevented ||
      e.button !== 0 ||
      e.metaKey ||
      e.altKey ||
      e.ctrlKey ||
      e.shiftKey
    ) {
      return
    }
    e.preventDefault()
    history.push(bookUrl)
  }

  return (
    <OuterCardContainer backgroundcolor={highlightColor}>
      <InnerCardContainer>
        <CardData>
          {!description || (
            <StyledTitle fontcolor={fontColor}>{description}</StyledTitle>
          )}
          <StyledText fontcolor={fontColor}>
            {`${t(dateFull)} ${t('at')} ${hour}`}
          </StyledText>
          {activities.map((activity) => {
            if (
              isShowActivitiesWithNoDuration === false &&
              activity.startsAt.isSame(activity.endsAt)
            )
              return null
            return (
              <StyledText fontcolor={fontColor}>{activity.name}</StyledText>
            )
          })}
          <LastMinutePrice
            isShowPrice={showPrice}
            fontColor={fontColor}
            regularTotal={regularTotal}
            lastMinutePrice={lastMinutePrice}
          />
        </CardData>
        <LinkButton
          href={bookUrl}
          onClick={handleClick}
          backgroundcolor={backgroundColor}
          fontcolor={highlightColor}
        >
          {t('Book')}
        </LinkButton>
      </InnerCardContainer>
    </OuterCardContainer>
  )
}
